import { Component } from '@angular/core';
import {CardComponent} from '../../../../shared/components/card/card.component';

@Component({
  selector: 'page-page-imprint',
  imports: [
    CardComponent
  ],
  templateUrl: './page-imprint.component.html',
  styleUrl: './page-imprint.component.scss'
})
export class PageImprintComponent {

}
